import { isAllowedIpOrCidr } from "src/services/ipRestriction";
import { z } from "zod";

export const emptyApiCredential: ApiCredentialFormType = {
  client_name: "",
  client_description: "",
  role: "",
  team_id: "",
  allowed_ips: [],
};

const allowedIpsSchema = z
  .array(z.string())
  .refine(
    (values) => values.every((value) => isAllowedIpOrCidr(value.trim())),
    {
      message: "Each entry must be a valid IP address or CIDR",
    }
  )
  .refine(
    (values) => {
      const normalized = values.map((value) => value.trim()).filter(Boolean);
      return new Set(normalized).size === normalized.length;
    },
    { message: "Duplicate IP addresses are not allowed" }
  );

export const ApiCredentialFormSchema = z.object({
  client_name: z.string().trim().min(1, { message: "This field is required" }),
  client_description: z.string().trim(),
  role: z.string().min(1, { message: "This field is required" }),
  team_id: z.string(),
  allowed_ips: allowedIpsSchema,
});

export const ApiCredentialValidator = {};

export type ApiCredentialFormType = z.infer<typeof ApiCredentialFormSchema>;
